import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NgFor, NgIf, SlicePipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { MessageCenterService } from "src/app/core/api_services/message-center.service";
import { MessageCenter } from "src/app/core/_models/news-article.model";
import { MatDialog } from "@angular/material/dialog";
import { MessageDetailsDialogComponent } from "../../message-details-dialog/message-details-dialog.component";
import { CustomDatePipe } from "src/app/shared/pipes/custom-date.pipe";

@Component({
  selector: "app-simple-update-notification-table",
  templateUrl: "./simple-update-notification-table.component.html",
  styleUrls: ["./simple-update-notification-table.component.scss"],
  imports: [NgIf, NgFor, TranslatePipe, CustomDatePipe, SlicePipe],
})
export class SimpleUpdateNotificationTableComponent implements OnInit {
  public messagesHolder;
  public messages: MessageCenter[] = [];

  constructor(
    private messageCenterService: MessageCenterService,
    private domSanitizer: DomSanitizer,
    public dialog: MatDialog,
  ) {}
  ngOnInit(): void {
    this.loadMessages();
  }

  loadMessages(): void {
    this.messageCenterService.getMessages(true).subscribe(
      (messages) => {
        this.messages = messages
          .sort(
            (a, b) =>
              new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime(),
          )
          .slice(0, 5);
      },
      (error) => {
        console.error("Error loading messages:", error);
        this.messages = [];
      },
    );
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
  showMessageModal(message: MessageCenter) {
    this.dialog.open(MessageDetailsDialogComponent, {
      width: "600px",
      data: message,
      autoFocus: false,
    });
  }
}
